import React from 'react'
import { setAuthStartedCookie } from '@mc/email-capture'
import { Trans } from '@mc/i18n'
import { EMAIL_CAPTURE_I18N } from '../constants'
import { WarningBox } from './WarningBox'

export const EmailAlreadyRegisteredWarning = ({
  redirectPath,
  onClick,
}: {
  redirectPath: string
  onClick: (action: string) => void
}) => {
  const handleClick = (evt: React.MouseEvent<HTMLAnchorElement>) => {
    // get Anchor text
    const { textContent } = evt.target as HTMLElement

    if (textContent) {
      setAuthStartedCookie()
      onClick(textContent)
    }
  }

  return (
    <WarningBox>
      <Trans i18nKey='email.alreadyExist' ns={EMAIL_CAPTURE_I18N}>
        {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
        <a
          className='mc-text--link'
          onClick={handleClick}
          href={redirectPath}
        />
      </Trans>
    </WarningBox>
  )
}
